import { assignInlineVars } from "@vanilla-extract/dynamic";
import { headshot, headshotWrap, height, width } from "./Headshot.css";

export default function Headshot({
	src,
	alt,
	className,
	w = 80,
	h = 80,
}: {
	src: string;
	alt: string;
	className?: string;
	w?: string | number;
	h?: string | number;
}) {
	return (
		<span
			className={`${className} ${headshotWrap}`}
			style={assignInlineVars({
				[width]: typeof w === "number" ? `${w}px` : w,
				[height]: typeof h === "number" ? `${h}px` : h,
			})}
		>
			<img src={src} alt={alt} className={headshot} />
		</span>
	);
}
